export function setLanguage(language: string) {
  const nuxtApp = useNuxtApp()
  nuxtApp.$i18n.setLocale(language)
  // localStorage.setItem('language', language) // language 是移除了，后续无事就删除
  if (language === 'ar') {
    document.body.style.direction = 'rtl'
  } else {
    document.body.style.direction = 'ltr'
  }
  document.body.className = language
}
